import React from "react";
import { TextField } from "@mui/material";
import { formatarMoeda } from "@/utils/formatCurrency"; // Importa a função de formatação

interface TextFieldComponentProps {
  label: string
  name: string
  value?: string | number
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void
  fullWidth?: boolean
  type?: string
  height?: string
  width: string
  titleTop?: boolean
  required?: boolean
  disabled? : boolean
  minWidth?: string
}

export function TextFieldComponent({ label, name, value, onChange, onBlur, fullWidth = true, type, titleTop = false, width, height, required, ...props }: TextFieldComponentProps) {

  const InputProps = {
    style: {
      height: height ?? "6vh",
      width: width
    },
  };

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    if (type === "currency") {
      const rawValue = event.target.value.replace(/\D/g, "");
      const formattedValue = formatarMoeda(parseFloat(rawValue) / 100);
      // Criando estrutura para R$
      const customEvent = {
        ...event,
        target: {
          ...event.target,
          value: formattedValue,
        },
      };
      onChange(customEvent as React.ChangeEvent<HTMLInputElement>);
    } else {
      onChange(event);
    }
  }

  return (
    <TextField
      label={label}
      name={name}
      fullWidth={fullWidth}
      value={value}
      type={type} // Evita que o tipo seja definido para "currency"
      onChange={handleChange}
      onBlur={onBlur}
      InputProps={InputProps}
      InputLabelProps={{ shrink: titleTop }} // Usa titleTop para controlar o shrink do label
      required={required ?? false}
      disabled={props.disabled ?? false}
      style={{
        minWidth: props.minWidth
      }}
      sx={{
        '& input[type=number]': {
          MozAppearance: 'textfield',
          appearance: 'textfield',
        },
        '& input[type=number]::-webkit-outer-spin-button': {
          WebkitAppearance: 'none',
          margin: 0,
        },
        '& input[type=number]::-webkit-inner-spin-button': {
          WebkitAppearance: 'none',
          margin: 0,
        },
      }}
      {...props}
    />
  );
}
